module.exports = __webpack_public_path__ + "img/career-a2.bff391dd.webp";